import axios from "axios";
import operators from "../../models/horarios/operators";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getDelegationOperatorsForId() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    // Convertir operId a número
    let operId = parseInt(localStorage.getItem("operId"));

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/workflow/delegar/${operId}`, { headers })
      .then(({ data }) => {
        return data.map((item) => {
          return operators.fromJson(item);
        });
      });
  }

  async newDelegation(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const operid = localStorage.getItem("operId");
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload = {
      operId: parseInt(operid, 10),
      deleOperId: parseInt(data.name),
      deleDesde: data.from + "T00:00:00.000Z",
    };

    if (data.to !== null) {
      payload.deleHasta = data.to + "T00:00:00.000Z";
    }

    return axios.post(`${url}/workflow/actividades/delegacion`, payload, {
      headers,
    });
  }
  getShowDelegationOperId() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    // Convertir operId a número
    let operId = parseInt(localStorage.getItem("operId"));

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/workflow/delegar/puede/${operId}`, { headers })
      .then(({ data }) => {
        return data;
      });
  }
}
export default service;
